module.exports = __webpack_public_path__ + "static/media/honey-pot.54a97214.svg";